import { inject, Injectable } from '@angular/core';
import {
  DeviceReadOnlyControllerService,
  DeviceSummary
} from '@garmin-avcloud/avcloud-fly-web-common/api/devices/read';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
@Injectable()
export class DevicesServiceWithCache {
  private readonly deviceService = inject(DeviceReadOnlyControllerService);
  private readonly cache: Map<number, Observable<DeviceSummary | null>> = new Map();

  getAndCache(id: number): Observable<DeviceSummary | null> {
    let device: Observable<DeviceSummary | null> | undefined = this.cache.get(id);

    if (device === undefined) {
      device = this.deviceService.getDevice(id).pipe(
        tap((result: DeviceSummary | null) => {
          if (result != null) {
            this.cache.set(id, of(result));
          }
        })
      );
      this.cache.set(id, device);
    }

    return device;
  }

  getAndCacheSummaries(): Observable<DeviceSummary[] | null> {
    return this.deviceService.getAllDevices().pipe(
      tap((result: DeviceSummary[] | null) => {
        if (result != null) {
          result.forEach((summary) => {
            const id = summary.id;
            const observable = of(summary);
            this.cache.set(id, observable);
          });
        }
      })
    );
  }
}
